import FormValidator from "@web/vpt-assets/assets/js/utilities/validations/formValidator";

export default class UserRegisterHandler {
    constructor({registerCallback, saveRegisterCookie}) {
        this.form = document.querySelector('#form-user-register');
        if (!this.form) {
            return;
        }
        this.formValidator = new FormValidator(this.form, {
            customValidators: {
                'checkPassword': (input) => this.checkPasswordRepeated(input),
                'sizePassword': (input) => this.checkSizePassword(input)
            }
        });
        this.registerCallback = registerCallback;
        if (saveRegisterCookie) {
            this.saveRegisterCookie = saveRegisterCookie;
        }
        this.eventDelegation();
    };

    eventDelegation() {
        this.form.querySelector('#userEmail').addEventListener('inputValidated', (formMessage) => {
            const errorMessage = document.querySelector("#userEmailMessage");
            if (!formMessage.detail.isValid && formMessage.detail.failedValidator == 'email') {
                errorMessage.style.display = "block";
            } else {
                errorMessage.style.display = "none";
            }
        });


        this.form.addEventListener('submit', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.formValidator.validateForm()) {
                const formButton = this.form.querySelector('[data-entity="form-user-register-button"]');
                if (formButton) {
                    formButton.disabled = true;
                    formButton.classList.add('disabled');
                }

                const response = await this.registerCallback();

                if (!response.status || !response.message) return;

                document.querySelector('[name="registerInfo"]').style.display = 'none';
                const responseContainer = document.querySelector('[data-container="form-response-form-user-register"]');
                responseContainer.style.display = '';

                const responseTitleContainer = responseContainer.querySelector('[data-response-form-title]');
                responseTitleContainer.innerHTML = response.title;

                responseTitleContainer.style.display = '';
                const responseMsgContainer = responseContainer.querySelector('[data-response-form-description]');
                responseMsgContainer.innerHTML = response.message;

                const loginButton = responseContainer.querySelector('[data-entity="loginButton"]');
                const rememberPassword = responseContainer.querySelector('[data-entity="forgot-password"]');
                const registerAdvantage = responseContainer.querySelector('[data-entity="register-advantage"]');
                rememberPassword.style.display = 'none';

                if (response.status === 400 || response.status === 403 || response.status === 401) {
                    loginButton.style.display = 'none';
                    registerAdvantage.style.display = 'none';
                    return;
                }

                registerAdvantage.style.display = '';
                loginButton.style.display = '';

                if (response.status === 200 && this.saveRegisterCookie) {
                    this.saveRegisterCookie();
                }
            }
        });
    }

    checkPasswordRepeated(input) {
        const newPassword = document.querySelector('#userPassword');
        const nameInput = input.id;
        const errorMessage = document.querySelector("#" + nameInput + "Message");
        if (newPassword && newPassword.value === input.value) {
            errorMessage.style.display = "none";
        } else {
            errorMessage.style.display = "block";
        }

        return newPassword && newPassword.value === input.value;
    }

    checkSizePassword(input) {
        const nameInput = input.id;
        const errorMessage = document.querySelector("#" + nameInput + "Message");
        if (input.value.length >= 6) {
            errorMessage.style.display = "none";
        } else {
            errorMessage.style.display = "block";
        }
        return input.value.length >= 6;
    }

}
